import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../../layout/kmc/Index";
import BuildingInfrastructureSection from "../../components/kmc/sections/BuildingInfrastructureBlock";
import ListOfDoctorsBlock from "../../components/kmc/sections/DoctorsBlock";
import ServicesSection from "../../components/kmc/sections/ServiceBlock";
import TabsBlock from "../../components/kmc/sections/TabsBlock";
import UpdateSection from "../../components/kmc/sections/UpdateBlock";
import HealthCampSection from "../../components/kmc/sections/HealthBlock";
import OffersBlock from "../../components/kmc/sections/OfferBlock";
import TestimonialsBlock from "../../components/kmc/sections/TestimonialsBlock";
import "../../assets/styles/kmc.scss";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import BannerBlock from "../../components/kmc/sections/BannerBlock";
import { KanhaYoutubeLink } from "../../assets/data/config";
import Seo from "../../components/seo";
import SpecialDoctors from "../../components/kmc/sections/SpecialDoctors";
import Healthray from "../../components/healthray-widget";

const index = () => {
  return (
    <>
      <Seo title="Kanha Medical Centre" pagepath="kmc" />
      <Layout>
        <BannerBlock />
        <Healthray />
        <section className="bg-white py-5">
          <div className="container-fluid">
            <div className="section-bg">
              <div className="row justify-content-center">
                <div className="col-sm-12 col-md-3 col-lg-3 text-center py-4">
                  <div className="details-img">
                    <StaticImage
                      src="../../assets/images/kmc-images/413764.png"
                      alt=""
                    />
                  </div>
                  <p className="text-white text-font pt-2">
                    Schedule your <br />
                    Appointment <br />9 AM to 5 PM Mon-Sat <br />
                    10 AM - 1 PM Sun
                  </p>
                  <p className="text-white text-font">
                    085482 49008
                    <br />
                    091333 55446
                  </p>
                </div>
                <div className="col-sm-12 col-md-3 col-lg-3 text-center">
                  <div className="bg-addon py-4">
                    <div className="details-img">
                      <StaticImage
                        src="../../assets/images/kmc-images/898643.png"
                        alt=""
                      />
                    </div>
                    <p className="text-white text-font pt-3">
                      Pharmacy
                      <br />
                      24*7
                    </p>
                    <p className="text-white text-font">
                      085482 49035
                      <br />
                      086397 13974
                      <br />
                    </p>
                    <p> </p>
                  </div>
                </div>
                <div className="col-sm-12 col-md-3 col-lg-3 text-center py-4">
                  <div className="details-img">
                    <StaticImage
                      src="../../assets/images/kmc-images/4873992.png"
                      alt=""
                    />
                  </div>
                  <p className="text-white text-font pt-2">
                    Laboratory
                    <br />
                    7.30 am to 4 pm Mon-Sat
                    <br />
                    Sunday : Holiday
                  </p>
                  <p className="text-white text-font">
                    085482 49032
                    <br />
                    085482 49008
                  </p>
                </div>
                <div className="col-sm-12 col-md-3 col-lg-3 text-center">
                  <div className="bg-addons py-4">
                    <div className="details-img">
                      <StaticImage
                        src="../../assets/images/kmc-images/664493.png"
                        alt=""
                      />
                    </div>
                    <p className="text-white text-font pt-2">
                      Emergency
                      <br />
                      24*7
                      <br />
                      091333 10393
                      <br />
                      091333 55446
                    </p>
                    <p
                      className="text-white text-font"
                      id="Building_Infrastructure"
                    >
                      Ambulance
                      <br />
                      24*7
                      <br />
                      079812 84023
                      <br />
                      091333 10393
                    </p>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-white py-3 building-Infrastructure">
          <div className="container-fluid">
            <BuildingInfrastructureSection />
          </div>
        </section>
        <section className="bg-white py-3 doctors-services">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <h3>ACCESS QUALITY HEALTH CARE</h3>
                <h2>Doctors &amp; Services</h2>
              </div>
            </div>
            <div className="row justify-content-center pt-4">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="medical-center-offers">
                  <StaticImage
                    src="../../assets/images/kmc-images/20211125_ASH_5535.png"
                    alt="Doctors &amp; Services"
                  />
                  <div className="medical-center-blueBox">
                    <p>
                      The Medical Centre offers Outpatient consultation and day
                      care treatment, follow up and stabilization of critically
                      ill and transport.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-white pt-5 pb-4 list-doctors">
          <div className="container-fluid">
            <ListOfDoctorsBlock />
          </div>
        </section>
        <section className="bg-white pt-5 pb-4 list-doctors special_doctors">
          <div className="container-fluid">
            <SpecialDoctors />
          </div>
        </section>

        <section className="bg-light pt-5 other-services">
          <div className="container">
            <div className="row text-center pb-4">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <h4>
                  Kindly contact Reception for appointment and availability of
                  the doctors
                </h4>
                <h2>091333 55446</h2>
                <h2>085482 49008</h2>
              </div>
            </div>
          </div>
        </section>
        <section className="other-servicesBG py-5">
          <div className="container-fluid">
            <ServicesSection />
          </div>
        </section>
        <section className="bg-white py-4 pb-5 SpecialistTabs">
          <div className="container-fluid">
            <TabsBlock />
          </div>
        </section>
        <section className="py-5 update-section">
          <div className="container-fluid">
            <UpdateSection />
          </div>
        </section>
        <section className="bg-white pt-5 pb-5 health-camps">
          <div className="container-fluid">
            <HealthCampSection />
          </div>
        </section>
        <section className="bg-white pt-0 pb-0 building-Infrastructure">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <h2>Listing Activities</h2>
                <p>
                  During the COVID times with the support of the government, our
                  centre organized mass testing of all the villagers for COVID
                  by rapid antigen, isolation, monitoring, treatment, referral
                  services, with zero mortality in both the 1st and the 2nd
                  waves of COVID. Our centre played a major role in achieving
                  full covid vaccination status for the surrounding villages.
                </p>
                <p className="health-publishDate" id="offers">
                  February 12, 2022
                </p>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <StaticImage
                  src="../../assets/images/kmc-images/list-infra-s.png"
                  alt="Listing Activities"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="bg-white pt-3 pb-4 health-camps health-camps-offers-block">
          <div className="container-fluid">
            <OffersBlock />
          </div>
        </section>
        <section className="bg-white py-3 testimonials">
          <div className="container-fluid">
            <TestimonialsBlock />
          </div>
        </section>
        <section
          id="job_kmc"
          className="bg-white pt-3 pb-5 opportunities-events"
        >
          <div className="container-fluid">
            <div className="row justify-content-center pb-2">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <h2>Jobs</h2>
              </div>
            </div>
            <div className="container pt-3">
              <div className="row">
                <div className="col-sm-4">
                  <p className="opportunities-events-ptag mb-0">
                    <b>BSc nursing 1 year experience</b>
                  </p>
                  <p className="mb-2">2 posts</p>
                </div>
                <div className="col-sm-4">
                  <p className="opportunities-events-ptag mb-0">
                    <b>Dental assistant</b>
                  </p>
                  <p className="mb-2">1 posts</p>
                </div>
                <div className="col-sm-4">
                  <p className="opportunities-events-ptag mb-0">
                    <b>Ambulance driver</b>
                  </p>
                  <p className="mb-2">post 1</p>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <p className="opportunities-events-ptag mb-0">
                    <b>Emergency medical technician</b>
                  </p>
                  <p className="mb-2">post 1</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="py-5 KMC-Section">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-sm-12 col-md-12 col-lg-6">
                <iframe
                  className="responsive-iframe"
                  src={KanhaYoutubeLink}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; 
                clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <div className="col-sm-12 col-md-12 col-lg-6">
                <div className="">
                  <h2 className="text-white">Kanha Medical Centre</h2>
                  <p className="text-white">
                    Kmc commits to deliver holistic treatment,considering
                    physical,mental,spiritual well being of the individuals
                    through a system of qualified,senior,experienced
                    doctors&staff who communicate,counsel,support,treat,and
                    encourage all the patients to promote recovery from illness
                    and well being supported by latest equipment and
                    infrastructure. To provide Healthcare to the poorer sections
                    of the community who are deprived of quality health care
                    with in their reach. KMC offers the most probable diagnosis
                    at the first visit , with very focused diagnostic work up,
                    with compassionate communication with patient and family
                    members instilling faith and confidence of regaining health
                    in the shortest time possible. Kmc works with the aim of
                    preventing hospitalization of any patient visiting ,by
                    following the methodology of quick,accurate diagnosis and
                    immediate primary,right treatment including parenteral
                    medications. KMC builds trust with the patients giving
                    utmost value for councelling and proper communication as the
                    main part of every treatment.The freedom of choosing the
                    modality of treatment is offered to the patient.Patient
                    choice is respected Kmc works to improve psychological
                    health by offering sessions of relaxation and meditation
                    free of cost that makes the treatment approach holistic. Kmc
                    working with the professionals all over India to provide
                    regular specialist services regularly and envisions
                    expansion towards world class diagnostic and research
                    facility in parallel with establishment of Maternal and
                    child health division, Radiation oncology unit, Cancer unit,
                    Spine foundation, Paediatric rehabilitation ect.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid pt-5">
            <div className="row justify-content-center text-center">
              <div className="col-sm-4 col-md-3 col-lg-3">
                <div className="kmc-br-sec">
                  <h2 className="text-white pt-3 kmc-graphs">35</h2>
                  <p className="text-white kmc-graphsText">Doctors</p>
                </div>
              </div>
              <div className="col-sm-4 col-md-3 col-lg-3">
                <div className="kmc-br-sec">
                  <h2 className="text-white pt-3 kmc-graphs">2250</h2>
                  <p className="text-white kmc-graphsText">Patients</p>
                </div>
              </div>
              <div className="col-sm-4 col-md-3 col-lg-3">
                <div className="kmc-br-sec">
                  <h2 className="text-white pt-3 kmc-graphs">20000</h2>
                  <p className="text-white kmc-graphsText">Lab Tests</p>
                </div>
              </div>
              <div className="col-sm-4 col-md-3 col-lg-3">
                <div className="kmc-br-sec">
                  <h2 className="text-white pt-3 kmc-graphs">450</h2>
                  <p className="text-white kmc-graphsText" id="contact_us">
                    Health Camps
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="kmc-contributions pt-5 contributionskmc">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <h2>Develop Love through Service</h2>
                <p className="mt-4">
                  Kanha Shanti Vanam is providing affordable Health Care
                  facility to majority residents of the Kanha Village, since
                  last five years. Quality of service is not compromised to make
                  it affordable. So, to make both ends meet we need support from
                  generous donors like you. Please extend your valuable support
                  and participate in the noble cause. Your contribution can make
                  valuable change in the life of poor underprivileged
                  population. Please consider donating whatever you feel to
                  give, but there is no compulsion to donate. It all depends on
                  your means and willingness!
                </p>
                <p className="mb-5">
                  All donations are exempted under section 80G of Income Tax act
                  1961.
                </p>
                <div className="text-center">
                  <a
                    href=" https://donations.heartfulness.org/donation-general-fund "
                    className="donate-btn"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Donate Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="contact-map-section contactUsKmc pt-5">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-3 col-sm-12 col-md-4 text-center">
                <div className="contact-columnBg p-5">
                  <h3>Visit Us</h3>
                  <p>9 am to 8 pm Mon-Sat</p>
                  <p>10 am to 1 pm Sun</p>
                  <h3 className="pt-3">Call Us At</h3>
                  <p>085482 49008</p>
                  <p>091333 55446</p>
                  <h3 className="pt-3">Our Location</h3>
                  <p>
                    KanhaShantivanam,
                    <br />
                    Kanha Medical Centre,
                    <br />
                    Chegur Village,
                    <br />
                    Chegur 509328,
                    <br />
                    Telangana
                  </p>
                  <p className="pb-4" />
                </div>
              </div>
              <div className="col-lg-9 col-sm-12 col-md-8">
                <iframe
                  title="Tracker"
                  referrerpolicy="no-referrer-when-downgrade"
                  loading="lazy"
                  width="100%"
                  height="100%"
                  className="map-iframe"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15247.655022604578!2d78.2200774!3d17.174406!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9e3e172dffad6b0e!2sMedical%20Center%2C%20Kanha%20Shanti%20Vanam!5e0!3m2!1sen!2sin!4v1671769529457!5m2!1sen!2sin"
                />
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

export default index;
